import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import Modal from '../../containers/common/Modal';
import ScalePicker from '../../containers/health-content/ScalePicker';
import { postCurrentWeight } from '../../services';

import closeIcon from '../../images/health-content/close-modal.svg';
import AddIcon from '../../images/health-content/add-icon.svg';
import ClockIcon from '../../images/health-content/clock-icon.svg';
import WeightIcon from '../../images/health-content/weight-icon.svg';
import { FlyInTransition } from '../transitions/transitions';

const WeightModal = ({ hideModal, weightDate, scaleVal }) => {
  const [showModal, setShowModal] = useState(true);
  const [scaleValue, setScaleValue] = useState(scaleVal);
  const [weightData, setWeightDate] = useState(weightDate);
  const timer = useRef(null);
  const { authToken } = useSelector((state) => state.user);

  useEffect(() => {
    if (!showModal)
      timer.current = setTimeout(() => {
        hideModal();
      }, 300);
    return () => {
      clearTimeout(timer);
      timer.current = null;
    };
  }, [showModal]);
  return (
    <Modal>
      <div
        className="modalContainer"
        onClick={(e) => {
          e.stopPropagation();
          setShowModal(false);
        }}
      >
        <FlyInTransition in={showModal} mountOnEnter unmountOnExit appear>
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            className="modalBody"
          >
            <div
              style={{
                paddingLeft: '0',
                paddingRight: '0',
                overflowY: 'auto',
                minHeight: '150px',
              }}
            >
              <div className="flex justify-between items-center border-b border-txtlight-shades4">
                <div className="flex items-center p-20px py-16px">
                  <img src={WeightIcon} alt=""></img>
                  <p className="ml-12px text-body-m font-semibold">Weight</p>
                </div>
                <img
                  src={closeIcon}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(false);
                  }}
                  className="pr-20px"
                />
              </div>
              <div className="flex py-40px justify-between items-center flex-col h-full">
                <p className="text-title-l font-bold">
                  What is your current weight?
                </p>
                <div className="text-center my-4">
                  <span className="text-header-xl font-bold">{scaleValue}</span>
                  <span>Kgs</span>
                </div>
                <ScalePicker
                  start={30}
                  end={200}
                  value={scaleValue}
                  onChange={(value) => setScaleValue(value)}
                />
                <div className="flex flex-col justify-center items-center">
                  <div className="flex mt-52px">
                    <img src={ClockIcon} alt=""></img>
                    {/* <p className="text-card-body text-sub ml-8px">
                      Last Logged On
                    </p> */}
                    <p className="text-body-s ml-8px">
                      {weightData ? weightData.updatedOn : ''}
                    </p>
                  </div>
                </div>
                <div className="pb-20px px-20px mt-28px w-full">
                  <button
                    onClick={async () => {
                      try {
                        await postCurrentWeight(authToken, {
                          weight: scaleValue,
                          measuredOn: new Date().toISOString().slice(0, 10),
                        });
                        setShowModal(false);
                      } catch (error) {
                        console.error('Error posting weight:', error);
                      }
                    }}
                    className="flex justify-center w-full bg-primary text-txtlight mb-20px rounded-12 text-body-s font-semibold py-14px"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </FlyInTransition>
      </div>
    </Modal>
  );
};

export default WeightModal;
